var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }